import React, { useState } from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';

import { selectSportHistoryLocale } from 'features/sportHistory/redux/selectors';

import './StakeItem.scss';

const b = block('stake-item');

const StakeItem = ({ item }) => {
  const locale = useSelector(selectSportHistoryLocale);

  return (
    <div className={b({ status: item.status })}>
      <div className={b('item')}>
        <div className={b('label')}>{locale.outcome}</div>
        <div className={b('value')}>{item.outcome}</div>
      </div>

      <div className={b('item')}>
        <div className={b('label')}>{locale.coef}</div>
        <div className={b('value')}>{item.coef}</div>
      </div>

      <div className={b('item')}>
        <div className={b('label')}>{locale.score}</div>
        <div className={b('value')}>{item.score}</div>
      </div>

      <div className={b('item')}>
        <div className={b('label')}>{locale.status.title}</div>
        <div className={b('value', { status: item.status })}>{locale.status?.[item.status] ?? item.status}</div>
      </div>
    </div>
  );
};

export default StakeItem;
